import { render, staticRenderFns } from "./ReceiptVoucher.vue?vue&type=template&id=3364f7d6&scoped=true&"
import script from "./ReceiptVoucher.vue?vue&type=script&lang=js&"
export * from "./ReceiptVoucher.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptVoucher.vue?vue&type=style&index=0&id=3364f7d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364f7d6",
  null
  
)

export default component.exports